import React from 'react'
import styled from 'styled-components'

export type Props = {
  buttonType?: 'MEDIUM' | 'SMALL',
  children: React.ReactNode,
  className?: string,
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const StyledDefaultButton = styled.button`
  width: 100%;
  border: none;
  border-radius: 20rem;
  font-weight: 700;
  text-align: center;

  &:focus {
    outline: 0;
  }

  &:hover {
    text-decoration: none;
    opacity: .7;
  }

  &:disabled {
    background: #dbdde3;
    color: ${props => props.theme.members.colors.silver._70};
    opacity: 1;

    &:hover {
      cursor: no-drop;
    }
  }
`

const StyledMediumButton = styled(StyledDefaultButton)`
  font-size: .875rem;
  height: 2.875rem;
  line-height: 2.875rem;
  padding: 0 .75rem;
`

const StyledSmallButton = styled(StyledDefaultButton)`
  font-size: .8175rem;
  padding: .5rem 1rem;
  text-align: center;

  &:focus {
    outline: 0;
  }

  &:hover {
    text-decoration: none;
  }

  &:disabled {
    background: #dbdde3;
    color: ${props => props.theme.members.colors.silver._70};
    opacity: 1;

    &:hover {
      cursor: no-drop;
    }
  }
`

export const StyledButton: React.FC<Props> = ({ children, buttonType, ...buttonProps }: Props) => {
  switch (buttonType) {
    case 'MEDIUM':
      return <StyledMediumButton {...buttonProps}>{children}</StyledMediumButton>
    case 'SMALL':
      return <StyledSmallButton {...buttonProps}>{children}</StyledSmallButton>
    default:
      return <StyledMediumButton {...buttonProps}>{children}</StyledMediumButton>
  }
}
